var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button hamburger",class:{'is-active': _vm.$store.state.sideMenuActive},on:{"click":_vm.toggleMenu}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }